enum AccountStateReasonCode {
    Inactive = "INACTIVE",
    Manual = "MANUAL",
    CassSwitch = "CASS_SWITCH",
    FtdMatured = "FTD_MATURED",
    FtdUnderfunded = "FTD_UNDERFUNDED",
    EarlyBreakage = "EARLY_BREAKAGE",
}

export default AccountStateReasonCode;